export const newHeaderMapper = ['', 'Domestic', 'International', 'Platinum']

export const newHeaderMap = newHeaderMapper.sort((a, b) => (a > b ? 1 : -1))

export const newCardTypeDropdownData = [
  { id: 110, value: 'Debit Card', isSelected: false, isChecked: false },
  { id: 130, value: 'Credit Card', isSelected: false, isChecked: false },
  { id: 131, value: 'Prepaid Card', isSelected: false, isChecked: false },
  { id: 140, value: 'Food Card', isSelected: false, isChecked: false },
  { id: 141, value: 'UPI', isSelected: false, isChecked: false },
  { id: 132, value: 'H', isSelected: false, isChecked: false },
  { id: 133, value: 'R', isSelected: false, isChecked: false },
]

export const getCardIdFromName = (name: string) => {
  return `${newCardTypeDropdownData.filter((data) => data.value === name)[0].id}`
}
